export const settingsPagePreviousUrl = '/opportunity/board';
